export const environment = {
    production: false,
    apiUrl: 'https://stage.api.switchpay.eu/mobilepayapi/api.php',
    apiCore: 'https://stage.api.switchpay.eu/api/api.php'
};
